// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".defaultPage{margin-left:auto;margin-right:auto;min-height:calc(100vh - 366px)}.main-body-content{max-width:940px}.otherColor{background-color:#d9d9d9;margin-top:5px}.cookie-consent{align-items:center;align-self:center;border-bottom:1px solid #fff;display:flex;justify-content:center;padding:10px}.cookie-consent button{border:1px solid #fff;margin-left:20px;min-width:140px;padding:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
